import { forwardRef } from 'preact/compat'
import type { JSX } from 'preact'

export type Props = Omit<JSX.IntrinsicElements['button'], 'loading'> & {
	loading?: boolean
	backColor?: string
}

const PureButton = forwardRef<HTMLButtonElement, Props>(
	(
		{
			type = 'button',
			class: _class = '',
			loading,
			disabled,
			children,
			backColor,
			...props
		},
		ref,
	) => (
		<button
			style={{
				backgroundColor: backColor ? backColor : '#da1884',
				borderColor: backColor ? backColor : '#da1884',
			}}
			{...props}
			className={_class}
			disabled={disabled || loading}
			type={type}
			ref={ref}
		>
			{loading ? <span class='loading loading-spinner' /> : children}
		</button>
	),
)

export default PureButton
